module.exports = __webpack_public_path__ + "static/illust01-9c36dd0dda6a1c3b6d6fc07ce3ce50c3.png";